<template>
    <v-container page>
        <!-- ส่วนหัว -->
        <v-layout>
            <v-flex>
                <img src="@/assets/kiosk_logo2.jpg" width="200">
            </v-flex>
            <v-flex text-right mr-2>
                <v-layout>
                    <v-flex>
                        <h2>ใบขนส่งสินค้า</h2>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex text-right fontHead>
                        <strong>วันที่ขึ้นของ</strong>
                        {{loadDate}}
                    </v-flex>
                    <v-flex text-right fontHead>
                        <strong>วันที่ส่งของ</strong>
                        {{deliDate}}
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex text-right fontHead>
                        <strong>ชื่อคนขับรถ</strong>
                        {{driver}}
                    </v-flex>
                    <v-flex text-right fontHead>
                        <strong>เลขทะเบียน</strong>
                        {{regNum}}
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <!-- เลขที่ -->
        <v-layout>
            <v-flex fontHead>
                <strong>เลขที่ : </strong>
                {{transNo}}
            </v-flex>
        </v-layout>

        <v-layout v-if="tripDays">
            <v-flex fontHead><strong>ทริป {{ tripDays }} วัน</strong></v-flex>
        </v-layout>

        <!-- ส่วนโครง -->
        <div v-for="(item,i) in deliveryList" :key="i">
            <div v-if="item.dayHead" class="fontHead mt-2"><strong>วันที่ {{ item.dayHead.day }} – {{ item.dayHead.date }}</strong></div>
            <div style="line-height:10px;"><br></div>
            <v-layout>
                <v-flex>
                    <div class="fontHead page-break-inside">
                        <v-layout>
                            <v-flex>
                                <strong>จังหวัด : </strong>
                                {{item.city}}
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs5>
                                <strong>รหัสร้านค้า : </strong>
                                {{item.cardCode}}
                            </v-flex>
                            <v-flex>
                                <strong>โทรศัพท์ : </strong>
                                {{item.cardPhone}}
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <strong>ชื่อร้านค้า : </strong>
                                {{item.cardName}}
                            </v-flex>
                        </v-layout>
                    </div>
                    <template v-if="item.custName != ''">
                        <v-card-text style="border-top: 1px solid black;">
                            <v-layout>
                                <v-flex xs5>
                                    <strong><font color="black">ชื่อลูกค้า : </font></strong>
                                    <font color="black">{{item.custName}}</font>
                                </v-flex>
                                <v-flex xs3>
                                    <strong><font color="black">โทรศัพท์ : </font></strong>
                                    <font color="black">{{item.custTel}}</font>
                                </v-flex>
                                <v-flex>
                                    <strong><font color="black">เวลา : </font></strong>
                                    <font color="black">{{item.time}}</font>
                                </v-flex>
                                <v-flex text-right>
                                    <strong><font color="black">นัดแล้ว : </font></strong>
                                    <input class="frame" size="1" disabled>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    <strong><font color="black">ที่อยู่ : </font></strong>
                                    <font color="black">{{item.custAddress}}</font>
                                </v-flex>
                                <v-flex xs2>
                                    <strong><font color="red" size="2">{{item.payMent}} 
                                        {{item.transferAmt}}</font></strong>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </template>
                    <template v-if="item.prodList.length > 0">
                        <table style="width:100%;">
                                <tr class="table font">
                                    <th style="text-align: left;">เลขที่ SO</th>
                                    <th style="text-align: left;">รหัสสินค้า</th>
                                    <th style="text-align: left;">รายละเอียด</th>
                                    <th style="text-align: center;">โครง</th>
                                    <th style="text-align: center;">บาน</th>
                                    <th style="text-align: right;">จำนวน</th>
                                    <th style="text-align: right;">ปริมาตร</th>
                                    <th style="text-align: center;">เกรด</th>
                                    <th style="text-align: left;">เลขที่ PO</th>
                                    <th style="text-align: left;">หมายเหตุ</th>
                                </tr>
                                <tr v-for="(item,i) in item.prodList" :key="i" class="font">
                                    <td style="text-align: left;">{{item.soNo}}</td>
                                    <td style="text-align: left;">{{item.prodCode}}</td>
                                    <td style="text-align: left;">{{item.desc}}</td>
                                    <td style="text-align: center;">{{item.frame}}</td>
                                    <td style="text-align: center;">{{item.front}}</td>
                                    <td style="text-align: right;">{{item.qty}}</td>
                                    <td style="text-align: right;">{{item.volume}}</td>
                                    <td style="text-align: center;">{{item.grade}}</td>
                                    <td style="text-align: left;">{{item.poNo}}</td>
                                    <td style="text-align: left;">{{item.remark}}</td>
                                </tr>
                                <tr class="table font">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td style="text-align: right;"><strong>รวม</strong></td>
                                    <td style="text-align: right;">
                                        <strong>
                                            {{item.totalVolume.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                        </strong>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                        </table>
                        <v-divider></v-divider>
                    </template>
                    <template v-if="item.prodListRt.length > 0">
                        <h3><font color="red">สินค้ารับคืน</font></h3>
                        <v-divider></v-divider>
                        <table style="width:100%" class="table">
                                <tr class="table font">
                                    <th style="text-align: left;">เลขที่ RT</th>
                                    <th style="text-align: left;">รหัสสินค้า</th>
                                    <th style="text-align: center;">โครง</th>
                                    <th style="text-align: center;">บาน</th>
                                    <th style="text-align: center;">จำนวน</th>
                                    <th style="text-align: left;">สาเหตุ</th>
                                    <th style="text-align: left;">วิธีแก้ไข</th>
                                </tr>
                                <tr v-for="(item,i) in item.prodListRt" :key="i" class="font">
                                    <td style="text-align: left;">{{item.rtNo}}</td>
                                    <td style="text-align: left;">{{item.prodName}}</td>
                                    <td style="text-align: center;">{{item.frame}}</td>
                                    <td style="text-align: center;">{{item.front}}</td>
                                    <td style="text-align: center;">{{item.qty}}</td>
                                    <td style="text-align: left;">{{item.remark}}</td>
                                    <td style="text-align: left;">{{item.solution}}</td>
                                </tr>
                        </table>
                    </template>
                </v-flex>
            </v-layout>
            <template v-if="i == deliveryList.length - 1">
                <br>
                <v-layout class="fontHead">
                    <v-flex xs3 text-right>
                        <strong>รวมปริมาตรทั้งหมด</strong>
                    </v-flex>
                    <v-flex xs1 text-right>
                        <strong>{{sumVolume.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong>
                    </v-flex>
                    <v-flex></v-flex>
                    <v-flex>
                        <strong>Signnature : </strong>
                        <strong>______________</strong>
                    </v-flex>
                    <v-flex>
                        <v-layout>
                            <v-flex>
                                <strong>Date : </strong>
                                <strong>___________</strong>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <strong>FM-DL-01, REV:02</strong>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </template>
        </div>

    </v-container>
</template>
<script>
import {db} from '@/firebase'
import DR from '@/components/deliveryRow'
export default {
    data(){
        return{
            deliveryList: [],
            tripDays: 0,

            loadDate: '',
            deliDate: '',
            driver: '',
            regNum: '',

            transNo: this.$route.query.transNo,

            prodHeader:[
                { text: 'เลขที่ SO', sortable: false, align: 'left', value: 'soNo' },
                { text: 'รหัสสินค้า', sortable: false, align: 'left', value: 'prodCode' },
                { text: 'รายละเอียด', sortable: false, align: 'left', value: 'desc' },
                { text: 'โครง', sortable: false, align: 'center', value: 'frame' },
                { text: 'บาน', sortable: false, align: 'center', value: 'front' },
                { text: 'จำนวน', sortable: false, align: 'right', value: 'qty' },
                { text: 'ปริมาตร', sortable: false, align: 'right', value: 'volume' },
                { text: 'เกรด', sortable: false, align: 'center', value: 'grade' },
                { text: 'เลขที่ PO', sortable: false, align: 'left', value: 'poNo' },
                { text: 'หมายเหตุ', sortable: false, align: 'left', value: 'remark' },
                // { text: '', sortable: false, value: 'action' },
            ],

            prodHeaderRt: [
                { text: 'เลขที่ RT', sortable: false, align: 'left', value: 'rtNo' },
                { text: 'รหัสสินค้า', sortable: false, align: 'left', value: 'prodName' },
                { text: 'โครง', sortable: false, align: 'center', value: 'frame' },
                { text: 'บาน', sortable: false, align: 'center', value: 'front' },
                { text: 'จำนวน', sortable: false, align: 'center', value: 'qty' },
                { text: 'สาเหตุ', sortable: false, align: 'left', value: 'remark' },
                { text: 'วิธีแก้ไข', sortable: false, align: 'left', value: 'solution' },
            ],

            prodServiceHeader:[
                { text: 'เลขที่ SO', sortable: false, align: 'left', value: 'soNo' },
                { text: 'รหัสสินค้า', sortable: false, align: 'left', value: 'prodCode' },
                { text: 'รายละเอียด', sortable: false, align: 'left', value: 'desc' },
                { text: 'โครง', sortable: false, align: 'center', value: 'frame' },
                { text: 'บาน', sortable: false, align: 'center', value: 'front' },
                { text: 'จำนวน', sortable: false, align: 'right', value: 'qty' },
                // { text: 'ราคาค่าซ่อม', sortable: false, align: 'right', value: 'price' },
            ],
        }
    },
    methods:{
        test(){
            // db.collection("deliveryList").doc("yGpJg1rk4PABP7Y03mEV").get()
            // .then(query=>{
            //     let data = query.data()
            //     db.collection("deliveryList").add({
            //         cardCode: data.cardCode,
            //         cardName: data.cardName,
            //         cardPhone: data.cardPhone,
            //         city: data.city,
            //         custAddress: data.custAddress,
            //         custName: data.custName,
            //         custTel: data.custTel,
            //         deliveryDate: data.deliveryDate,
            //         driver: data.driver,
            //         driverName: data.driverName,
            //         loadDate: data.loadDate,
            //         payMent: data.payMent,
            //         prodList: data.prodList,
            //         prodListRt: data.prodListRt,
            //         regNum: data.regNum,
            //         soNo: data.soNo,
            //         status: data.status,
            //         time: data.time,
            //         timeStampEnd: data.timeStampEnd,
            //         timeStampEndBy: data.timeStampEndBy,
            //         timeStampStart: data.timeStampStart,
            //         timeStampStartBy: data.timeStampStartBy,
            //         timeUpdate: data.timeUpdate,
            //         transNo: 'aaa',
            //     })
            //     .then(()=>{
            //         console.log("Success.")
            //     })
            // })
        },

        getDeliveryList(){
            db.collection("deliveryList").orderBy("cardCode").orderBy("custName").where("transNo", "==", this.transNo).get()
            .then(query=>{
                this.deliveryList = []
                let arr = []
                query.forEach(doc=>{
                    arr.push(doc.data())
                })
                let loadDateSplit = query.docs[0].data().loadDate.split("-")
                let yearThaiLoadDate = loadDateSplit[0]*1 + 543
                let deliDateSplit = query.docs[0].data().deliveryDate.split("-")
                let yearThaiDeliDate = deliDateSplit[0]*1 + 543
                this.loadDate = loadDateSplit[2] + "-" + loadDateSplit[1] + "-" + yearThaiLoadDate
                this.deliDate = deliDateSplit[2] + "-" + deliDateSplit[1] + "-" + yearThaiDeliDate

                this.driver = query.docs[0].data().driver
                this.regNum = query.docs[0].data().regNum
                let newArr = []
                let cardCode = null
                let cardName = null
                let cardPhone = null
                let city = null
                let custAddress = null
                let custName = null
                let custTel = null
                let payMent = null
                let transferAmt = null
                let prodList = []
                let prodListRt = []
                let soNo = null
                let time = null
                let planDate = null
                let planSeq = null
                let tripEnd = null
                let count = 0
                arr.forEach(rec=>{
                    if(rec.custName != custName || rec.cardCode != cardCode){
                        if(count > 0){
                            newArr.push({ cardCode: cardCode, cardName: cardName, cardPhone: cardPhone,
                                city: city, custAddress: custAddress, custName: custName, custTel: custTel, transferAmt: transferAmt,
                                payMent: payMent, prodList: prodList, prodListRt: prodListRt, soNo: soNo, time: time,
                                planDate: planDate, planSeq: planSeq, tripEnd: tripEnd
                            })
                        }
                        cardCode = rec.cardCode
                        cardName = rec.cardName
                        cardPhone = rec.cardPhone
                        city = rec.city
                        custAddress = rec.custAddress
                        custName = rec.custName
                        custTel = rec.custTel
                        payMent = rec.payMent
                        transferAmt = null
                        if(rec.transferAmt){
                            transferAmt = rec.transferAmt
                        }
                        prodList = []
                        rec.prodList.forEach(a=>{
                            prodList.push(a)
                        })
                        prodListRt = []
                        rec.prodListRt.forEach(a=>{
                            prodListRt.push(a)
                        })
                        soNo = rec.soNo
                        time = rec.time
                        planDate = rec.planDate || null
                        planSeq = rec.planSeq == null ? null : rec.planSeq
                        tripEnd = rec.tripEnd || null
                        count = 1
                    }
                    else{
                        if(payMent == '' || transferAmt == ''){
                            payMent = rec.payMent
                            transferAmt = rec.transferAmt
                        }
                        rec.prodList.forEach(a=>{
                            prodList.push(a)
                        })
                        rec.prodListRt.forEach(a=>{
                            prodListRt.push(a)
                        })
                        if(rec.planSeq != null && (planSeq == null || rec.planSeq < planSeq)){
                            planSeq = rec.planSeq
                            planDate = rec.planDate || planDate
                        }
                        count++
                    }
                })
                if(count > 0){
                    newArr.push({ cardCode: cardCode, cardName: cardName, cardPhone: cardPhone,
                        city: city, custAddress: custAddress, custName: custName, custTel: custTel, transferAmt: transferAmt,
                        payMent: payMent, prodList: prodList, prodListRt: prodListRt, soNo: soNo, time: time,
                                planDate: planDate, planSeq: planSeq, tripEnd: tripEnd
                    })
                }
                newArr.forEach(rec=>{
                    rec.totalVolume = 0
                    rec.prodList.forEach(res=>{
                        rec.totalVolume += res.volume
                    })
                    rec.prodList.sort((a,b)=>a.soNo - b.soNo)
                    if(rec.prodListRt){
                        rec.prodListRt.sort((a,b)=>a.rtNo - b.rtNo)
                    }
                })
                newArr.sort((a, b)=>{
                    if(a.time){
                        return a.time.localeCompare(b.time)
                    }
                    else{
                        if(a.city){
                            return a.city.localeCompare(b.city)
                        }
                    }
                })
                // A planned trip prints in the plan's order under day headings
                // (deliveryRow.sheetDays); any other sheet keeps the order above.
                const planned = DR.sheetDays(newArr)
                if (planned) newArr = planned
                const end = newArr.map(r => r.tripEnd).filter(Boolean).sort().slice(-1)[0]
                this.tripDays = end && end > query.docs[0].data().deliveryDate
                    ? Math.round((Date.parse(end) - Date.parse(query.docs[0].data().deliveryDate)) / 86400000) + 1 : 0
                this.deliveryList = newArr
                setTimeout(() => {
                    window.print()
                    window.close()
                }, 1)
            })
        },
    },
    computed:{
        sumVolume(){
            return this.deliveryList.reduce((total,item)=>total+(item.totalVolume),0)
        }
    },
    mounted(){
        this.getDeliveryList()
    }
}
</script>
<style scoped>
@media print {
  body {
    margin: 0;
    padding: 0;
  }

  .A4 {
    box-shadow: none;
    margin: 0;
    width: auto;
    height: auto;
  }

  .noprint {
    display: none;
  }

  .enable-print {
    display: block;
  }
}
.page {
    width: 210mm;
    /* min-height: 297mm; */
    /* background: rgb(255, 255, 255); */
    background: white;
}
@page{
    /* size: A4; */
    margin: 15px 10px 10px 10px;
}
@media print
{
    .page-break-inside{ page-break-inside:avoid; }
}
.fontHead{
    font-size: 4mm;
}
.font{
    font-size: 3.5mm;
}
.table{
    border-top: 1px solid black;
    border-bottom: 1px solid black;
}
.frame{
    border-top: 1px solid black;
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
}
table, th, td {
  /* border: 1px solid black; */
  border-collapse: collapse;
  padding: 2px;
}
</style>